<template>
  <el-dialog
    title="分红详情"
    :visible.sync="dialogVisible"
    width="900px"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <div v-loading="loading">
      <!-- 订单摘要 -->
      <div class="summary_box">
        <div class="order_no">订单号：{{ order.order_no || "-" }}</div>
        <div class="summary_grid">
          <div class="summary_item">
            <div class="summary_label">结算时间</div>
            <div class="summary_value">{{ summary.poolprofit_time || "-" }}</div>
          </div>
          <div class="summary_item">
            <div class="summary_label">订单金额</div>
            <div class="summary_value">{{ order.pay_price || "0.00" }} 元</div>
          </div>
          <div class="summary_item">
            <div class="summary_label">总分红池</div>
            <div class="summary_value">{{ summary.poolprofit_price || "0.00" }} 元</div>
          </div>
          <div class="summary_item multi_fields">
            <div class="field">
              <div class="summary_label">店长分红人数</div>
              <div class="summary_value">{{ summary.keeper_num || 0 }}</div>
            </div>
            <div class="field">
              <div class="summary_label">分红金额</div>
              <div class="summary_value">{{ summary.poolprofit_keeper_price || "0.00" }}</div>
            </div>
          </div>
          <div class="summary_item multi_fields">
            <div class="field">
              <div class="summary_label">合伙人人数</div>
              <div class="summary_value">{{ summary.partner_num || 0 }}</div>
            </div>
            <div class="field">
              <div class="summary_label">分红金额</div>
              <div class="summary_value">{{ summary.poolprofit_partner_price || "0.00" }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 分红记录 -->
      <div class="record_search">
        <el-input
          v-model="search.post.keyword"
          placeholder="请输入会员昵称、手机号"
          size="small"
          clearable
          style="width: 220px"
          @keyup.enter.native="handleSearch"
        />
        <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
      </div>

      <el-tabs v-model="activeTab" @tab-click="handleTabChange">
        <el-tab-pane label="店长分红记录" name="1"></el-tab-pane>
        <el-tab-pane label="合伙人分红记录" name="2"></el-tab-pane>
      </el-tabs>

      <el-table :data="search.table" border style="width: 100%">
        <el-table-column label="用户信息" min-width="200">
          <template #default="{ row }">
            <div class="user_cell">
              <img
                class="user_avatar"
                :src="(row.user && row.user.avatar && row.user.avatar.url) ? row.user.avatar.url : require('@/static/img/people.png')"
                alt=""
              />
              <div class="user_info">
                <div>{{ (row.user && (row.user.true_name || row.user.nick_name)) || "-" }}</div>
                <div class="user_mobile">{{ (row.user && row.user.mobile) || "-" }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="可分红金额" align="center" min-width="120">
          <template #default="{ row }">
            {{ row.price || "0.00" }}
          </template>
        </el-table-column>
        <el-table-column prop="entry_status" label="是否入账" align="center" min-width="100">
          <template #default="{ row }">
            <el-tag v-if="row.entry_status == 1" type="success" size="small">已入账</el-tag>
            <el-tag v-else type="warning" size="small">待入账</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="120" fixed="right">
          <template #default="{ row }">
            <el-button
              v-if="row.entry_status == 0"
              type="text"
              size="small"
              style="color: #f56c6c"
              @click="cancelDividend(row)"
            >取消分红</el-button>
            <span v-else style="color: #999">已分红</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="page_box">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="search.post.page"
          :page-sizes="[15, 30, 50, 100]"
          :page-size="search.post.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="search.total"
        />
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button class="base_but_style base_save_but" type="primary" @click="handleExport">导出</el-button>
      <el-button class="base_but_style" @click="handleClose">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { eltips } from "@/util/util.js";
export default {
  name: "poolprofitDetailModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      activeTab: "1",
      search: {
        post: {
          page: 1,
          limit: 15,
          keyword: "",
        },
        table: [],
        total: 0,
      },
      summary: {},
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.activeTab = "1";
        this.search.post.page = 1;
        this.search.post.limit = 15;
        this.getList();
      }
    },
    dialogVisible(val) {
      this.$emit("update:visible", val);
    },
  },
  methods: {
    getList() {
      if (!this.order.order_id) return;
      let params = {
        ...this.search.post,
        order_id: this.order.order_id,
        poolprofit_type: this.activeTab,
        change_type: 1,
      };
      if (!params.keyword) delete params.keyword;
      this.loading = true;
      this.axios
        .get("/api/weishop/admin/plugin/poolprofit/balance/index", { params })
        .then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.search.table = res.data.data || [];
            this.search.total = res.data.total || 0;
            this.summary = {
              poolprofit_time: res.data.poolprofit_time || this.order.poolprofit_time,
              poolprofit_price: res.data.poolprofit_price || this.order.poolprofit_price,
              keeper_num: res.data.keeper_num,
              partner_num: res.data.partner_num,
              poolprofit_keeper_price: res.data.poolprofit_keeper_price,
              poolprofit_partner_price: res.data.poolprofit_partner_price,
            };
          } else {
            eltips(res.msg, "error");
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleTabChange() {
      this.search.post.page = 1;
      this.search.post.keyword = "";
      this.getList();
    },
    handleSearch() {
      this.search.post.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.search.post.limit = val;
      this.search.post.page = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.search.post.page = val;
      this.getList();
    },
    handleExport() {
      eltips("导出未开发", "warning");
    },
    cancelDividend(row) {
      // 取消分红占位
      eltips("取消分红未开发", "warning");
    },
    handleClose() {
      this.dialogVisible = false;
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.summary_box {
  background: #f8f9fb;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 15px;
  .order_no {
    margin-bottom: 15px;
    color: #333;
  }
  .summary_grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 15px;
  }
  .summary_item {
    background: #fff;
    border-radius: 4px;
    padding: 12px 15px;
  }
  .multi_fields {
    display: flex;
    gap: 30px;
  }
  .summary_label {
    font-size: 13px;
    color: #999;
    margin-bottom: 8px;
  }
  .summary_value {
    font-size: 15px;
    color: #333;
    font-weight: bold;
  }
}
.user_cell {
  display: flex;
  align-items: center;
  padding: 5px 0;
  .user_avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
    object-fit: cover;
  }
  .user_info {
    text-align: left;
    .user_mobile {
      font-size: 12px;
      color: #999;
      margin-top: 4px;
    }
  }
}
.record_search {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}
.page_box {
  text-align: right;
  padding: 15px 0 0;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
::v-deep .el-dialog__body {
  padding: 20px 30px 10px !important;
}
</style>
